import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import TermLengthPage from '@rental-manager/pages/Onboarding/TermLengthPage/component';
import { DEFAULT_ERROR, PAYMENT_SETTINGS_UPDATED } from '@rental-manager/constants/NotificationConstants';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import paths from '@rental-manager/pathsManifest';
import { pageFlows } from '../../pageFlows';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId, fromDashboard }) => {
  const { leaseId, encodedLeaseId } = state.payments.landlord.onboarding[propertyId];
  const { currentTerm, leasesForProperty, newTermSettings } = state.payments.landlord.property;
  const propertyStatus = currentTerm.propertyStatus;
  const { firstDueDate, numberOfPayments, monthToMonth, editMode, paymentDayOfTheMonth, firstPossibleDueDate } =
    newTermSettings;
  const numberOfPaymentsUnformatted = fromDashboard ? currentTerm.numberOfPayments : numberOfPayments;
  const {
    startDate: startDateFromLease,
    endDate: endDateFromLease,
    paymentsEncodedLeaseId,
  } = leasesForProperty[leaseId] || {};

  return {
    showOneTimePayment: fromDashboard,
    firstDueDate,
    numberOfPayments: numberOfPaymentsUnformatted && Number(numberOfPaymentsUnformatted),
    monthToMonth,
    paymentDayOfTheMonth,
    editMode,
    rentTermsKey: '',
    propertyStatus,
    config: state.payments.landlord.config,
    startDateFromLease,
    endDateFromLease,
    encodedLeaseId,
    paymentsEncodedLeaseId,
    today: firstPossibleDueDate,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl }: Record<string, any>) => ({
  onSubmit: (paymentSettings: Record<string, any>, editMode: boolean) => {
    return Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() =>
        dispatch(
          saveNewTermSettings({
            monthToMonth: paymentSettings.monthToMonth,
            firstDueDate: paymentSettings.firstDueDate,
            numberOfPayments: paymentSettings.numberOfPayments,
            paymentEndDate: paymentSettings.paymentEndDate,
          }),
        ),
      )
      .then(() => editMode && dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => {
        if (editMode) {
          return dispatch(push(baseUrl + paths.dashboard.setupNewTermPage));
        } else {
          return dispatch(push(baseUrl + paths.dashboard.rentAmountPage));
        }
      })
      .then(() => editMode && dispatch(showModalNotification(PAYMENT_SETTINGS_UPDATED)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      });
  },
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (paymentSettings) => dispatchProps.onSubmit(paymentSettings, stateProps.editMode),
  onClose: () => dispatchProps.onClose(stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TermLengthPage);
